import { render, staticRenderFns } from "./productView.vue?vue&type=template&id=0b2712bc&scoped=true&"
import script from "./productView.vue?vue&type=script&lang=js&"
export * from "./productView.vue?vue&type=script&lang=js&"
import style0 from "./productView.vue?vue&type=style&index=0&id=0b2712bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2712bc",
  null
  
)

export default component.exports